document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-patient-details]').forEach(function (block) {
    const formIdField = block.querySelector('[form]');
    const formId = formIdField ? formIdField.getAttribute('form') : null;
    const form = formId ? document.getElementById(formId) : block.closest('form');

    if (!form) return;

    const requiredFields = block.querySelectorAll('[data-patient-required]');
    const dobField = block.querySelector('[data-patient-dob]');
    const errorBox = block.querySelector('[data-patient-error]');
    const ageErrorBox = block.querySelector('[data-patient-age-error]');
    const minAge = parseInt(block.getAttribute('data-min-age'), 10) || 5;

    const submitButton =
      form.querySelector('button[type="submit"], [name="add"]') ||
      document.querySelector('button[type="submit"][form="' + form.id + '"], [name="add"][form="' + form.id + '"]');

    function parseUKDate(value) {
      if (!value) return null;

      const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match) return null;

      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10) - 1;
      const year = parseInt(match[3], 10);

      const date = new Date(year, month, day);

      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month ||
        date.getDate() !== day
      ) {
        return null;
      }

      return date;
    }

    function calculateAge(value) {
      const dob = parseUKDate(value);
      if (!dob) return null;

      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();

      if (
        today.getMonth() < dob.getMonth() ||
        (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
      ) {
        age--;
      }

      return age;
    }

    function formatDobInput(value) {
      const digits = value.replace(/\D/g, '').slice(0, 8);

      if (digits.length <= 2) return digits;
      if (digits.length <= 4) return digits.slice(0, 2) + '/' + digits.slice(2);

      return (
        digits.slice(0, 2) +
        '/' +
        digits.slice(2, 4) +
        '/' +
        digits.slice(4)
      );
    }

    function validate(showErrors) {
      let allFilled = true;

      requiredFields.forEach(function (field) {
        const wrapper = field.closest('.patient-details__field');
        const filled = field.value && field.value.trim() !== '';

        if (!filled) allFilled = false;

        if (showErrors && wrapper) {
          wrapper.classList.toggle('patient-details__field--invalid', !filled);
        }
      });

      const age = dobField ? calculateAge(dobField.value) : null;
      const ageValid = age !== null && age >= minAge;
      const valid = allFilled && ageValid;

      if (dobField && showErrors) {
        const dobWrapper = dobField.closest('.patient-details__field');
        if (dobWrapper) {
          dobWrapper.classList.toggle('patient-details__field--invalid', !ageValid);
        }
      }

      if (errorBox) {
        errorBox.hidden = allFilled || !showErrors;
      }

      if (ageErrorBox) {
        ageErrorBox.hidden = !allFilled || ageValid;
      }

      if (submitButton) {
        submitButton.disabled = !valid;
        submitButton.style.opacity = valid ? '1' : '0.6';
        submitButton.style.cursor = valid ? 'pointer' : 'not-allowed';
      }

      return valid;
    }

    if (dobField) {
      dobField.addEventListener('input', function () {
        dobField.value = formatDobInput(dobField.value);
        validate(true);
      });
    }

    requiredFields.forEach(function (field) {
      field.addEventListener('input', function () {
        validate(true);
      });

      field.addEventListener('change', function () {
        validate(true);
      });
    });

    form.addEventListener('submit', function (event) {
      if (!validate(true)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    validate(false);
  });
});